import axios from "axios";
import Vue from 'vue';
import Vuex from 'vuex';
import urls from "../urls";
import user from "./modules/user";
import files from "./modules/files";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        user: user,
        files: files,
    },
    state: {
        'firstAttempt': true,
        'messages': [
            // {
            //     text: '',
            //     type: '',
            // }
        ],
        'siteName': 'HEAT Client Portal',
        'partnerLogo': '',
    },
    mutations: {
        addMessage (state, payload) {
            //Handle the case of either a message with a type or just raw strings
            if( typeof(payload) === 'string' || payload instanceof String) {
                state.messages.push({text: payload, type: ''});
                return;
            }
            state.messages.push({
                text: payload.text,
                type: (typeof(payload.type) === 'string' || payload.type instanceof String) ? payload.type.toLowerCase(): '',
            });
        },
        removeMessage (state, payload) {
            state.messages.splice(payload)
        },
        clearMessages (state, payload) {
            state.messages = [];
        },
        setAttempted (state, payload) {
            state.firstAttempt = false;
        },
        setSiteInformation (state, payload) {
            state.siteName = payload.siteName || 'HEAT Client Portal';
            state.partnerLogo = payload.partnerLogo || '';
        },
    },
    actions: {
        async getVersion(context) {
            if(typeof __INITIAL__STATE__ !== 'undefined'  && typeof __INITIAL__STATE__.version === 'object') {
                context.commit('setSiteInformation', __INITIAL__STATE__.version);
                return;
            }
            let response = await axios.get(urls.version);
            response.data.messages.forEach((message) => {
                context.commit('addMessage', message);
            });
            context.commit('setSiteInformation', response.data);
        }
    },
});

export default store;
